function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#77A0C5",
    fillOpacity: 0.4,
    style: {
      fill: "#77A0C5",
      fill: "color(display-p3 0.4667 0.6275 0.7725)",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6799 8H8.3465C8.1587 8 8 8.15805 8 8.34508V23.6154C8 23.8024 8.1587 23.9605 8.3465 23.9605H10.854C10.9598 24.0132 11.0683 24.0132 11.1476 23.9605H20.6408C20.7466 24.0132 20.855 24.0132 20.9344 23.9605H23.6535C23.8413 23.9605 24 23.8024 24 23.6154V8.34508C24 8.15805 23.8413 8 23.6799 8ZM23.3334 9.32763H16.6652C16.4774 9.32763 16.3187 9.48568 16.3187 9.6727C16.3187 9.85973 16.4774 10.0178 16.6652 10.0178H23.3334V10.6553H13.3325V8.66381H23.3334V9.32763ZM12.6659 8.66381V10.6553H8.66656V8.66381H12.6659ZM13.1447 21.0919L12.531 20.083L12.8246 19.7906L13.8112 20.4017C13.917 20.4807 14.0519 20.4807 14.1577 20.4017C14.4778 20.1883 14.8243 20.0566 15.1972 19.9776C15.3295 19.9513 15.4115 19.8459 15.4379 19.7379L15.7051 18.5947H16.1045L16.3716 19.7379C16.3981 19.8696 16.5039 19.9513 16.6123 19.9776C16.9853 20.0566 17.3318 20.191 17.6518 20.4017C17.7576 20.4807 17.8925 20.4807 17.9983 20.4017L18.985 19.7906L19.2786 20.083L18.6649 21.0655C18.5856 21.1709 18.5856 21.3052 18.6649 21.4106C18.8792 21.7293 19.0114 22.0744 19.0908 22.4458C19.1172 22.5775 19.223 22.6592 19.3315 22.6855L20.4794 22.9516V23.244H17.9983C17.919 22.1561 17.0117 21.2789 15.8929 21.2789C14.774 21.2789 13.8668 22.1561 13.7848 23.244H11.3037V22.9516L12.449 22.6855C12.5813 22.6592 12.6633 22.5538 12.6897 22.4458C12.7691 22.0744 12.9304 21.7293 13.1156 21.4106C13.2214 21.3316 13.2214 21.1972 13.142 21.0919H13.1447ZM17.3318 23.2703H14.4778C14.5571 22.5538 15.1708 21.969 15.9167 21.969C16.6626 21.969 17.2498 22.5538 17.3291 23.2703H17.3318ZM21.146 23.2703V22.7119C21.146 22.5512 21.0402 22.4195 20.8788 22.3932L19.678 22.1271C19.5986 21.8084 19.4637 21.5423 19.305 21.2499L19.9716 20.2147C20.0509 20.083 20.0245 19.9223 19.9187 19.7906L19.2786 19.1531C19.1728 19.0477 18.985 19.0214 18.8527 19.1004L17.8132 19.7642C17.546 19.6036 17.2524 19.4982 16.9588 19.4192L16.6917 18.2232C16.6652 18.0626 16.533 17.9572 16.3716 17.9572H15.4379C15.2792 17.9572 15.1443 18.0626 15.1179 18.2232L14.8507 19.4192C14.5571 19.4982 14.2635 19.6325 13.9964 19.7642L12.9569 19.1004C12.7981 19.0214 12.6368 19.0477 12.531 19.1531L11.8644 19.8169C11.7586 19.9223 11.7322 20.1093 11.8115 20.241L12.4781 21.2763C12.3167 21.5423 12.2109 21.8347 12.1316 22.1271L10.9307 22.3932C10.7694 22.4195 10.6636 22.5512 10.6636 22.7119V23.2703H8.66391V11.3191H23.3308V12.328H11.3301C11.1423 12.328 10.9836 12.4886 10.9836 12.673C10.9836 12.8574 11.1423 13.0181 11.3301 13.0181H23.3308V23.323H21.1433V23.2703H21.146Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8401 13.6556H10.1585C9.70617 13.6556 9.33057 14.0271 9.33057 14.4801C9.33057 14.9332 9.70352 15.302 10.1585 15.302H15.8401C16.2924 15.302 16.668 14.9306 16.668 14.4801C16.668 14.0297 16.295 13.6556 15.8401 13.6556ZM15.8401 14.6382H10.1585C10.0791 14.6382 9.99977 14.5592 9.99977 14.4801C9.99977 14.4011 10.0791 14.3195 10.1585 14.3195H15.8401C15.9194 14.3195 15.9988 14.3985 15.9988 14.4801C15.9988 14.5618 15.9194 14.6382 15.8401 14.6382Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8401 15.647H10.1585C9.70617 15.647 9.33057 16.0184 9.33057 16.4715C9.33057 16.9245 9.70352 17.2933 10.1585 17.2933H15.8401C16.2924 17.2933 16.668 16.9219 16.668 16.4715C16.668 16.021 16.295 15.647 15.8401 15.647ZM15.8401 16.6295H10.1585C10.0791 16.6295 9.99977 16.5505 9.99977 16.4715C9.99977 16.3924 10.0791 16.3108 10.1585 16.3108H15.8401C15.9194 16.3108 15.9988 16.3898 15.9988 16.4715C15.9988 16.5531 15.9194 16.6295 15.8401 16.6295Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67976 12.9918H10.3463C10.5341 12.9918 10.6928 12.8337 10.6928 12.6467C10.6928 12.4597 10.5341 12.3016 10.3463 12.3016H9.67976C9.49196 12.3016 9.33325 12.4597 9.33325 12.6467C9.33325 12.8337 9.49196 12.9918 9.67976 12.9918Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99981 9.32751H9.33325V9.99133H9.99981V9.32751Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0127 9.32751H10.3462V9.99133H11.0127V9.32751Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 9.32751H11.3328V9.99133H11.9993V9.32751Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.d5f1fca8893faa990351b39aad03fe4c.svg";
export { ForwardRef as ReactComponent };